export { EloApplePayIcon } from './apple-pay-icon'
